import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=0d84f124&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84f124",
  null
  
)

export default component.exports